import { jsx as _jsx } from "react/jsx-runtime";
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
export const Default = (props)=>{
    const styles = `${props?.params?.GridParameters ?? ''} ${props?.params?.Styles ?? ''}`.trimEnd();
    const rowStyles = [
        props.params.Styles1,
        props.params.Styles2,
        props.params.Styles3,
        props.params.Styles4,
        props.params.Styles5,
        props.params.Styles6,
        props.params.Styles7,
        props.params.Styles8
    ];
    const enabledPlaceholders = props.params.EnabledPlaceholders.split(',');
    const id = props.params.RenderingIdentifier;
    return /*#__PURE__*/ _jsx("div", {
        className: `component row-splitter ${styles}`,
        id: id ? id : undefined,
        children: enabledPlaceholders.map((ph, index)=>{
            const phKey = `row-${ph}-{*}`;
            const phStyles = `${rowStyles[+ph - 1] ?? ''}`.trimEnd();
            return /*#__PURE__*/ _jsx("div", {
                className: `container-fluid ${phStyles}`.trimEnd(),
                children: /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row",
                        children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                            name: phKey,
                            rendering: props.rendering
                        }, index)
                    }, index)
                }, index)
            }, index);
        })
    });
};
